// frontend/services/expenses.js
import api from './api';

export const expenseService = {
    getExpenses: (params) => api.get('/expenses', { params }).then(res => res.data),
    
    getExpense: (id) => api.get(`/expenses/${id}`).then(res => res.data),
    
    // ✅ FIX: Send as JSON, not FormData
    createExpense: (data) => {
        console.log('📤 Sending expense as JSON:', data);
        return api.post('/expenses', data, {
            headers: { 'Content-Type': 'application/json' }
        }).then(res => res.data);
    },
    
    updateExpense: (id, data) => api.put(`/expenses/${id}`, data).then(res => res.data),
    
    deleteExpense: (id) => api.delete(`/expenses/${id}`).then(res => res.data),
    
    getSummary: (params) => api.get('/expenses/summary', { params }).then(res => res.data),
    
    getVendors: () => api.get('/expenses/vendors').then(res => res.data),
    
    createVendor: (data) => api.post('/expenses/vendors', data).then(res => res.data),
    
    updateVendor: (id, data) => api.put(`/expenses/vendors/${id}`, data).then(res => res.data),
    
    deleteVendor: (id) => api.delete(`/expenses/vendors/${id}`).then(res => res.data),
    
    getCategories: () => api.get('/expenses/categories').then(res => res.data)
};